<ng-container [ngSwitch]="data.view">
  <div
    *ngSwitchCase="VarAreaView.CHECK_LIST"
    style="height: fit-content !important"
    class="checklist p-15px"
  >
    <div *ngFor="let item of form; let idx = index">
      <input
        type="checkbox"
        id="checklistItem{{ item.id }}"
        hidden
        [disabled]="data.disabled || !!item.completed_by_id"
        [checked]="item.completed"
        (change)="handleChecklistChange(idx)"
      />
      <label
        for="checklistItem{{ item.id }}"
        class="checklist-item d-flex align-items-start m-0 px-15px py-2"
        [ngClass]="{ 'btn btn-white': !item.completed_by_id }"
      >
        <span
          inlineSVG="assets/media/svg/icons/Code/Done-circle.svg"
          class="svg-icon svg-icon-lg m-0"
          [class.svg-icon-success]="form[idx].completed"
        ></span>
        <span
          class="flex-grow-1 d-flex flex-column align-items-start justify-content-center ml-15px"
        >
          <span class="font-weight-bold" [class.completed]="!!item.completed_by_id">{{
            item.description
          }}</span>
          <ng-container *ngIf="!!item.completed_by_id">
            <span class="font-size-xs">
              <span class="text-dark-50 font-weight-bold mr-2"
                >{{ 'TASK.CHECKLIST.COMPLETED_BY' | translate }}:</span
              >
              {{ item.completed_by_user?.fullName }}
            </span>
            <span class="font-size-xs">
              <span class="text-dark-50 font-weight-bold mr-2"
                >{{ 'TASK.CHECKLIST.COMPLETED_AT' | translate }}:</span
              >
              {{ item.completed_at + ' UTC' | date : 'yyyy-MM-dd hh:mm' }}
            </span>
          </ng-container>
        </span>
      </label>
    </div>
  </div>
  <div
    *ngSwitchCase="VarAreaView.INTERVENTION"
    style="height: fit-content !important"
    class="p-15px"
  >
    <form [formGroup]="form" class="h-100 w-100 m-0">
      <div
        style="min-height: 30px !important"
        class="d-flex align-items-center justify-content-between mb-15px"
      >
        <div>
          <span class="text-muted font-weight-bold mr-2"
            >{{ 'TASK.INTERVENTION.CATEGORY' | translate }}:</span
          >{{ data.content?.drp.category || '-' }}
        </div>
        <div>
          <span class="text-muted font-weight-bold mr-2"
            >{{ 'TASK.INTERVENTION.SOURCE' | translate }}:</span
          >{{ data.content?.drp.source || '-' }}
        </div>
        <div>
          <span class="text-muted font-weight-bold mr-2"
            >{{ 'TASK.INTERVENTION.PCNE_CODE' | translate }}:</span
          >{{ data.content?.drp.problem_code || '-' }}
        </div>
      </div>
      <hr class="mb-15px" />
      <div class="d-flex align-items-start mb-15px">
        <div class="flex-grow-1">
          <div class="mb-15px">
            <span class="font-weight-bolder mr-2"
              >{{ 'TASK.INTERVENTION.DRP_TITLE' | translate }}:</span
            >{{ data.content?.drp.title || '-' }}
          </div>
          <div>
            <span class="font-weight-bolder mr-2"
              >{{ 'TASK.INTERVENTION.DRP_TEXT' | translate }}:</span
            >{{ data.content?.drp.text || '-' }}
          </div>
        </div>
        <span
          *ngIf="data.content?.intervention_code.level.level as level"
          [matTooltip]="'TASK.INTERVENTION.LEVEL' | translate"
          class="label label-xl label-inline border-0"
          [ngClass]="getLevelClass(level)"
        >
          {{ level | enumFormat : '_' }}
        </span>
      </div>
      <div class="w-100 mb-15px">
        <kt-general-autocomplete
          #causesAutocomplete
          [label]="'TASK.INTERVENTION.CAUSES' | translate"
          [appearance]="'standard'"
          [chipList]="true"
          [change]="selectCauses.bind(this)"
          [dataPath]="'data'"
          [objects]="causesAutocomplete.value"
          [loadItemsFunction]="getCausesAutocomplete$"
          [optionFormatter]="formatCauseOption"
          [valueFormatter]="formatCauseOption"
          [formatNewObjectFn]="formatNewCause"
          [readOnly]="data.disabled"
        ></kt-general-autocomplete>
      </div>
      <mat-form-field appearance="outline" class="w-100 mb-15px">
        <mat-label>{{ 'TASK.INTERVENTION.INTERVENTION_NOTE' | translate }}</mat-label>
        <textarea
          matInput
          formControlName="interventionNote"
          rows="3"
          class="scroll"
          [perfectScrollbar]="{ wheelPropagation: false }"
        ></textarea>
      </mat-form-field>
      <hr class="mb-15px" />
      <div class="d-flex align-items-start mb-15px">
        <div class="flex-grow-1">
          <kt-general-autocomplete
            #acceptanceAutocomplete
            [label]="'TASK.INTERVENTION.INTERVENTION_ACCEPTANCE' | translate"
            [appearance]="'standard'"
            [dataPath]="'data'"
            [change]="selectAcceptance.bind(this)"
            [control]="form.get('acceptanceResult')"
            [loadItemsFunction]="getAcceptanceAutocomplete$"
            [optionFormatter]="formatAcceptanceOption"
            [valueFormatter]="formatAcceptanceOption"
            [readOnly]="data.disabled"
          ></kt-general-autocomplete>
        </div>
        <div class="flex-grow-1 ml-15px">
          <kt-general-autocomplete
            #outcomeAutocomplete
            [label]="'TASK.INTERVENTION.OUTCOME' | translate"
            [appearance]="'standard'"
            [dataPath]="'data'"
            [control]="form.get('outcome')"
            [change]="selectOutcome.bind(this)"
            [loadItemsFunction]="getOutcomeAutocomplete$"
            [optionFormatter]="formatOutcomeOption"
            [valueFormatter]="formatOutcomeOption"
            [readOnly]="data.disabled"
          ></kt-general-autocomplete>
        </div>
      </div>
      <mat-form-field appearance="outline" class="w-100 mb-15px">
        <mat-label>{{ 'TASK.INTERVENTION.OUTCOME_NOTE' | translate }}</mat-label>
        <textarea
          matInput
          formControlName="outcomeNote"
          rows="3"
          class="scroll"
          [perfectScrollbar]="{ wheelPropagation: false }"
        ></textarea>
      </mat-form-field>
    </form>
  </div>
  <div *ngSwitchCase="VarAreaView.FORM" style="height: fit-content !important" class="p-15px">
    <formio
      [form]="form?.schema"
      [submission]="form?.input"
      [readOnly]="data.disabled"
      (change)="handleFormChange($event.data)"
      #formioComponent
    ></formio>
  </div>

  <div
    *ngSwitchCase="VarAreaView.ACTION_EXECUTION_LOGS"
    style="height: fit-content !important"
    class="p-15px"
  >
    <div *ngIf="actionLogsLoading" style="height: 200px" class="d-flex flex-column align-items-center justify-content-center">
      <mat-spinner [strokeWidth]="5" [diameter]="100"></mat-spinner>
      <span class="text-muted font-weight-medium mt-4">Loading action logs...</span>
    </div>

    <div
      *ngIf="!actionLogsLoading && actionLogsLoadFailed"
      class="d-flex w-100 align-items-center justify-content-between alert alert-custom alert-light-danger px-4 py-2"
      role="alert"
    >
      <div class="d-flex align-items-center">
        <div class="alert-icon">
          <i class="flaticon-warning"></i>
        </div>
        <div class="alert-text">Unable to load action logs.</div>
      </div>

      <button type="button" class="btn btn-sm btn-danger ml-4" (click)="loadActionLogs()">Reload</button>
    </div>

    <div
      *ngIf="!actionLogsLoading && !actionLogsLoadFailed && !actionLogs.length"
      style="height: 300px"
      class="d-flex align-items-center justify-content-center text-muted font-weight-medium"
    >
      No action logs to display.
    </div>

    <div *ngIf="!actionLogsLoading && !actionLogsLoadFailed && actionLogs.length">
      <div
        *ngFor="let log of actionLogs; trackBy: log?.id"
        class="border border-light rounded-lg mb-15px"
      >
        <header class="d-flex align-items-start p-4">
          <h6 class="flex-grow-1 d-flex flex-column align-items-start m-0">
            {{ log.actionName || 'Unnamed action' }}
            <span class="text-muted font-size-base font-weight-normal mt-2">{{ log.actionType | enumFormat : '_' | uppercase }}</span>
          </h6>

          <span
            class="label label-lg label-inline ml-4"
            [ngClass]="actionExecutionStatusClass[log.status]"
          >
            {{ log.status | enumFormat : '_' | uppercase }}
          </span>
        </header>

        <main class="d-flex align-items-end p-4">
          <div class="flex-grow-1 d-flex flex-column align-items-start font-size-sm">
            <div class="mb-2">
              <span class="text-muted font-weight-medium">HTTP:</span>
              <span class="text-muted font-weight-medium ml-2">METHOD</span>
              <span class="text-dark font-weight-normal ml-2">{{ log.httpMethod ? (log.httpMethod | enumFormat : '_' | uppercase) : '-' }}</span>
              <span class="text-muted font-weight-medium mx-4">|</span>
              <span class="text-muted font-weight-medium">STATUS</span>
              <span
                class="ml-2"
                [ngClass]="
                  log.httpStatus !== null && log.httpStatus !== undefined
                    ? 'label label-sm label-inline label-pill ' + (log.httpStatus > 400 ? 'label-light-danger' : log.httpStatus > 300 ? 'label-light-warning' : 'label-light-success')
                    : ''
                "
              >
                {{ log.httpStatus !== null && log.httpStatus !== undefined ? log.httpStatus : '-' }}
              </span>
            </div>

            <div class="text-dark font-weight-normal">
              <span>{{ log.attemptCount !== null && log.attemptCount !== undefined ? log.attemptCount : '0' }}</span>
              <span class="ml-2">attempts were made{{ log.lastAttemptAt ? ',' : '.' }}</span>
              <span *ngIf="log.lastAttemptAt">
                <span class="ml-2">the last on</span>
                <span class="ml-2">{{ log.lastAttemptAt ? (log.lastAttemptAt + ' UTC' | date : 'MMM d, y, h:mm a') : '-' }}.</span>
              </span>
            </div>
          </div>

          <button
            *ngIf="canRetryAction(log.status)"
            type="button"
            [attr.aria-busy]="retryingActionLogId === log.id"
            [attr.aria-label]="'Retry ' + (log.actionName || 'action')"
            [disabled]="retryingActionLogId !== null"
            style="min-width: 125px !important"
            class="btn btn-sm btn-primary"
            [ngClass]="retryingActionLogId === log.id ? 'spinner spinner-right spinner-sm spinner-light' : ''"
            (click)="retryAction(log)"
          >
            {{ retryingActionLogId === log.id ? 'Retrying' : 'Retry' }}
          </button>
        </main>
      </div>
    </div>
  </div>

  <div *ngSwitchCase="VarAreaView.COMMENTS" class="h-100">
    <ng-container *ngIf="!showComments">
      <div
        class="d-flex flex-center bg-light-dark font-size-lg font-weight-bolder text-white h-100 p-15px"
      >
        This area will display comments when the Task is created.
      </div>
    </ng-container>
    <ng-container *ngIf="showComments">
      <kt-comments
        [type]="'TASK'"
        [id]="data.content?.taskId"
        [taskTemplateId]="data.content?.templateId"
        [comments]="data.content?.comments"
        [fromDialog]="false"
        (commentsChange)="inputChange.emit({ view: data.view, content: $event })"
      ></kt-comments>
    </ng-container>
  </div>
  <div *ngSwitchCase="VarAreaView.ACTIVITY_HISTORY" class="history h-100">
    <kt-task-history
      [taskId]="data.content.taskId"
      [stepId]="data.content.stepId"
      [showHeader]="false"
    ></kt-task-history>
  </div>
</ng-container>
